import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../services/localStorage/localStorage.service';
import { UserInfo } from '../models/user-info.model';

/**
 * Adds user context (GE and roles) for every request to the backend.
 * @param req
 * @param next
 * @returns
 */
export const logInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  const localStorageService = inject(LocalStorageService);
  const groupeEtablissement =
    localStorageService.getItem<string>('userDefaultGE') || '';
  const userObject = localStorageService.getItem<UserInfo>('currentUser');

  let serializedRoles = '';
  if (userObject !== null) {
    const roleNames = userObject.roles.map(role => role.name);
    serializedRoles = JSON.stringify(roleNames);
  }
  // URL encode the value to ensure it's safe for the header - some characters can cause crashes
  const encodedGroupeEtablissement = encodeURIComponent(groupeEtablissement);
  const newReq = req.clone({
    setHeaders: {
      'X-ENT-GroupeEtablissement': encodedGroupeEtablissement, // Add header with encoded value
      'X-ENT-Roles': serializedRoles,
    },
  });

  return next(newReq);
};
